import React from 'react';
import {
  StyleSheet, Text, View,
} from 'react-native';
import { Card, Colors } from 'react-native-paper';
import { appColors } from '../../assets/styles/global';
import { handleWebBrowser, pixelDimensions } from '../../config/utils';
import { AppButton } from '../form';

const CardMonth = ({
  paid = false, date, value, boleto, nf,
}) => {
  const formatDate = new Date(date);

  return (
    <Card style={styleCardMonth.card}>
      <View style={styleCardMonth.viewData}>
        <Text style={styleCardMonth.textMonth}>
          {formatDate.toLocaleDateString('pt-BR')}
        </Text>
        <Text style={styleCardMonth.textPrice}>
          R$
          {' '}
          {value}
        </Text>
      </View>
      <View style={styleCardMonth.viewButtons}>
        <AppButton
          size="bold"
          label={paid ? 'Nota Fiscal' : 'Emitir Boleto'}
          rippleColor={Colors.white}
          style={styleCardMonth.buttonBack}
          labelStyle={styleCardMonth.textBack}
          onPress={() => handleWebBrowser(paid ? nf : boleto)}
        />
        <View style={styleCardMonth.viewTextPayment}>
          <Text>{paid ? 'Pago' : 'Em Aberto'}</Text>
        </View>
      </View>
    </Card>

  );
};

const styleCardMonth = StyleSheet.create({
  card: {
    margin: pixelDimensions(2),
    padding: pixelDimensions(2),
    borderRadius: pixelDimensions(3),
  },
  viewData: {
    backgroundColor: appColors.primary,
    opacity: 0.7,
    padding: pixelDimensions(2),
    borderRadius: pixelDimensions(3),
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  textMonth: {
    fontSize: pixelDimensions(4.75),
    color: appColors.white,
  },
  textPrice: {
    fontSize: pixelDimensions(4.75),
    color: appColors.white,
  },
  viewButtons: {
    // padding: pixelDimensions(2),
    borderRadius: pixelDimensions(3),
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  viewTextPayment: {
    borderStyle: 'solid',
    padding: pixelDimensions(2),
    borderColor: appColors.primary,
    borderWidth: 1,
    borderRadius: pixelDimensions(3),
  },
  textBack: {
    color: Colors.white,
    fontSize: pixelDimensions(4.5),
  },
  buttonBack: {
    alignSelf: 'flex-end',

    paddingVertical: pixelDimensions(2),
    paddingHorizontal: pixelDimensions(6),
    marginHorizontal: pixelDimensions(4),
    marginVertical: pixelDimensions(2),
  },
});

export default CardMonth;
